import { BaseService } from './base.service';
import { IUserDetails, VCreateUserModel, UserDetails } from '../models/user';
import { UserTypes } from '../common/enums/user-types.enum';
import { GenericApiResponse } from '../models/generic/generic-api-response';
import { Uris } from '../common/constants';
import { IUser, UserDto } from '../models/user/user.model';

export interface IUserService {
  getUserInfo: () => Promise<IUserDetails>;
  updateUserInfo: (idUser: number, params: any, target?) => Promise<any>;
  validateBlock: (blockCode: string) => Promise<any>;
  register: (payload: VCreateUserModel) => Promise<any>;
  verifyRegisterToken: (token: string) => Promise<any>;
  initUser: (opts?: IUser) => IUser
}

export class UserService extends BaseService implements IUserService {
  /**
   *
   */
  private readonly USER_INFO: string = 'me';

  constructor() {
    super();
  }

  async getUserInfo(): Promise<IUserDetails> {
    return await super.get(this.USER_INFO)
      .then((res: IUserDetails) => {
        return Promise.resolve(res)
      })
      .catch(err => {
        console.log(err);
        localStorage.clear();
        return Promise.reject(err)
      })
  }

  async updateUserInfo(idUser: number, payload: any) {
    let { percentage, ...formatPayload } = payload;
    return await super.patch(this.USER_INFO + '/' + idUser, formatPayload, {
      onUploadProgress: (progressEvent) => this.onUploadProgress(progressEvent, payload)
    })
  }

  async validateBlock(blockCode: string) {
    return await super.post(Uris.CheckBlock, { block_ref: blockCode })
  }

  async register(payload: VCreateUserModel) {
    return await super.post(Uris.UserRegister, payload)
  }

  async verifyRegisterToken(token: string) {
    return await super.post(Uris.UserRegisterVerify, {
      action: "verifySignupLong",
      value: token
    })
  }

  initUser(opts?: IUser): IUser {
    return opts ? new UserDto(opts) : new UserDto
  }
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts